<template>
  <div class="lxm-empty">
    <img src="../images/login/empty.jpg" />
    <div class="lxm-empty__text">{{ text }}</div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../styles/index.styl'
  .lxm-empty
    font-size 14px
    color cloudy
    text-align center
    img
      width siz(270 / 2)
      height siz(270 / 2)
      margin-top siz(120)
  .lxm-empty__text
    margin-top: siz(30)
</style>

<script>
  export default {
    props: {
      text: String
    }
  }
</script>



// WEBPACK FOOTER //
// Empty.vue?a7c50c60